import { gql } from '@apollo/client';

const queryAccountsWithEnvironmentURIs = (environmentUri: string) => {
    return {
        variables: {
            environmentUri,
        },
        query: gql`
            query GetEnvironment($environmentUri: String) {
                getEnvironment(environmentUri: $environmentUri) {
                    AwsProdAccountId
                    AwsDevAccountId
                    AwsTestAccountId
                    AwsValAccountId
                    AwsToolAccountId

                    prodEnvironmentUri
                    devEnvironmentUri
                    testEnvironmentUri
                    valEnvironmentUri
                    toolingEnvironmentUri
                }
            }
        `,
    };
};
export default queryAccountsWithEnvironmentURIs;
